import { render } from "./LoyaltyImage.vue?vue&type=template&id=2c54f443"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/LoyaltyImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c54f443"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c54f443', __exports__)) {
    api.reload('2c54f443', __exports__)
  }
  
  module.hot.accept("./LoyaltyImage.vue?vue&type=template&id=2c54f443", () => {
    api.rerender('2c54f443', render)
  })

}


export default __exports__